module.exports = __webpack_public_path__ + "img/houses.74348b76.jpg";